const BASE_URL = window.location.origin

function changeUrlPortToAPIPort(url) {
  return url.replace(
    process.env.VUE_APP_LOCAL_PORT,
    process.env.VUE_APP_PORT_API
  )
}

export const getApiUrl = () => {
  if (process.env.VUE_APP_ENV == "production") return BASE_URL
  else return changeUrlPortToAPIPort(BASE_URL)
}
